import React from "react";
import type { IconName } from "./Icon/Icon";
import Icon from "./Icon/Icon";

type ButtonProps = {
  text?: string;
  iconName?: IconName;
  iconColor?: string;
  disabled?: boolean;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  type?: "button" | "submit" | "reset";
  iconPosition?: "left" | "right";
  displayIcon?: boolean;
  id?: string;
};

const Button: React.FC<ButtonProps> = ({
  text = "Submit",
  iconName = "check",
  iconColor,
  disabled = false,
  onClick,
  className = "btn-theme bg-grey-1 text-white hover:bg-grey-2 disabled:bg-disabled",
  type = "submit",
  iconPosition = "left",
  displayIcon = true,
  id,
}) => (
  <button
    type={type}
    className={className}
    disabled={disabled}
    onClick={onClick}
    id={id}
    aria-disabled={disabled ? true : false}
    aria-label={text}
  >
    {iconPosition === "left" && displayIcon && <Icon name={iconName} color={iconColor} />}
    {text}
    {iconPosition === "right" && displayIcon && <Icon name={iconName} color={iconColor} />}
  </button>
);

export default Button;
